class FormValidator {
  inputs = {}
  formGroup = {}

  errors = {}
  tabView = null
  modalVariableName = null
  el = null
  context = null

  constructor (context) {
    this.context = context
  }

  subscribeFormGroup (group) {
    let name = group.validateAlias || group.name
    this.formGroup[name] = group

    if (group.toName) {
      this.formGroup[group.toName] = group
    }
  }

  unsubscribeFormGroup (group) {
    let name = group.validateAlias || group.name
    if (this.formGroup.hasOwnProperty(name)) {
      delete this.formGroup[name]
    }
    this.unsubscribeInput(group)
    this.removeErrorByFieldName(name)

    if (group.toName) {
      if (this.formGroup.hasOwnProperty(group.toName)) {
        delete this.formGroup[group.toName]
      }
      this.removeErrorByFieldName(group.toName)
    }
  }

  subscribeInput (input, inputName) {
    let name = inputName || input.validateAlias || input.name
    this.inputs[name] = input
  }

  unsubscribeInput (input, inputName) {
    let name = inputName || input.validateAlias || input.name
    if (this.inputs.hasOwnProperty(name)) {
      delete this.inputs[name]
    }
    this.removeErrorByFieldName(name)
  }

  removeErrorByFieldName (name) {
    if (this.errors.hasOwnProperty(name)) {
      delete this.errors[name]
    }
  }

  resetErrors (fields) {
    fields.forEach(v => {
      this.inputs[v].error = null
      this.formGroup[v].error = null
    })
  }

  resetAllErrors () {
    for (let key in this.inputs) {
      this.inputs[key].error = null
    }

    for (let key in this.formGroup) {
      this.formGroup[key].error = null
    }
  }

  reset () {
    this.errors = {}
    this.tabView = null
    this.modalVariableName = null
    this.el = null
  }

  handleServerErrors (response, componentCtx = null, opts = {}) {
    let {tabVariableName = 'tabView'} = opts

    this.reset()

    let notFoundedErrorFields = {}
    let notFoundedErrorFieldsText = ''
    if (response.data && response.data.errors) {
      for (let fieldName in response.data.errors) {
        let found = false
        for (let nameOrValidateAlias in this.inputs) {
          let ctx = this.inputs[nameOrValidateAlias]
          // if (ctx.name === fieldName) {
          if (nameOrValidateAlias === fieldName) {
            found = true
            this.inputs[nameOrValidateAlias].error = response.data.errors[fieldName]
            if (!this.formGroup[nameOrValidateAlias]) {
              this.formGroup[nameOrValidateAlias] = {}
            }
            this.formGroup[nameOrValidateAlias].error = response.data.errors[fieldName]
            this.errors[fieldName] = response.data.errors[fieldName]

            // first tab with error
            if (ctx.tabView && !this.tabView) {
              this.tabView = ctx.tabView
              this.el = this.inputs[nameOrValidateAlias].getElement()
            }

            // first modal with error
            if (ctx.modalVariableName && !this.modalVariableName) {
              this.modalVariableName = ctx.modalVariableName
              this.el = this.inputs[nameOrValidateAlias].getElement()

              // set tab, where modal
              if (ctx.tabView) {
                this.el = this.inputs[nameOrValidateAlias].getElement()
                this.tabView = ctx.tabView
              }
            }
          }
        }

        if (found === false) {
          notFoundedErrorFields[fieldName] = response.data.errors[fieldName]
          notFoundedErrorFieldsText += response.data.errors[fieldName] + ' '
        }
      }
    } else {
      notFoundedErrorFieldsText = 'Не удалось разпознать ошибки, вероятно сервер временно недоступен'
    }

    this.openTabsAndModal(componentCtx, tabVariableName, opts)

    return {
      notFoundedErrorFields,
      notFoundedErrorFieldsText,
      errors: this.errors,
      hasError: true,
      tabView: this.tabView,
      modalVariableName: this.modalVariableName,
      el: this.el
    }
  }

  openTabsAndModal (componentCtx, tabVariableName, opts = {}) {
    let {disableAutoFocus = false} = opts
    // if exist component context, open tab and modal
    if (componentCtx) {
      if (this.tabView) {
        componentCtx[tabVariableName] = this.tabView
      }
      if (this.modalVariableName) {
        componentCtx[this.modalVariableName] = true
      }
      if (this.el && !disableAutoFocus) {
        if (this.focusTimeout) {
          clearTimeout(this.focusTimeout)
          this.focusTimeout = null
        }
        this.focusTimeout = setTimeout(() => {
          try {
            this.el.focus()

            // focusable if input in slot
            if (this.el.nodeName === 'DIV') {
              let inputs = this.el.getElementsByTagName('input')
              let selects = this.el.getElementsByTagName('select')
              if (inputs[0]) {
                inputs[0].focus()
              } else if (selects[0]) {
                selects[0].focus()
              }
              // focusable on same elemnt
              // used in onchange validation
            } else {
              this.el.focus()
            }
          } catch (e) {
            console.warn('Element null on not focusable', e)
          }
          try {
            // @fix: reopened tab after in onchange validation
            // el blur focus
            if (this.tabView) {
              componentCtx[tabVariableName] = this.tabView
            }
          } catch (e) {
            console.warn(e)
          }
        }, 150)
      }
    }
  }

  /**
   * @param componentCtx
   * @param opts
   * @returns {{errors, hasError: boolean, tabView: *, modalVariableName: *, el: *}}
   */
  validate (componentCtx = null, opts = {}) {
    let {tabVariableName = 'tabView', validateOnly = null} = opts
    if (!componentCtx && this.context) {
      componentCtx = this.context
    }

    this.reset()

    for (let key in this.inputs) {
      if (validateOnly && validateOnly !== key) {
        continue
      }

      let ctx = this.inputs[key]
      let {error, tabView, el, name, modalVariableName} = ctx.validate()

      if (error) {
        // first tab with error
        if (tabView && !this.tabView) {
          this.tabView = tabView
          this.el = el
        }
        // first modal with error
        if (modalVariableName && !this.modalVariableName) {
          this.modalVariableName = modalVariableName
          this.el = el
          // set tab, where modal
          if (tabView) {
            this.tabView = tabView
            this.el = el
          }
        }

        this.errors[key] = error
        this.inputs[key].error = error
        if (!this.formGroup[key]) {
          this.formGroup[key] = {}
        }
        this.formGroup[key].error = error
      } else {
        this.inputs[key].error = null
        if (!this.formGroup[key]) {
          this.formGroup[key] = {}
        }
        this.formGroup[key].error = null
      }
    }

    let out = {
      errors: this.errors,
      hasError: false,
      tabView: this.tabView,
      modalVariableName: this.modalVariableName,
      el: this.el
    }

    if (Object.keys(this.errors).length > 0) {
      out.hasError = true
    }

    this.openTabsAndModal(componentCtx, tabVariableName, opts)

    return out
  }
}

export default FormValidator
